import useStore from '../stores/store';

export const isOwnerInWs = (isShared, ownerId, userData) => {
    if (isShared) {
        let userId = userData.userId;
        if (userId === ownerId) {
            return true;
        } else {
            return false;
        }
    } else {
        return true;
    }
};
